// extracted by mini-css-extract-plugin
export default {"movie":"MovieGroup_movie__K9ein","show":"MovieGroup_show__BiJc8","Img":"MovieGroup_Img__fgYDa","letters":"MovieGroup_letters__eNyh5","title":"MovieGroup_title__EJuK5"};